'use strict';

import appModule from '../../app.module';

angular.module(appModule)
.controller('AdminPublicationsController', ['$scope', '$http', '$timeout', 'Auth', function($scope, $http, $timeout, Auth) {

  var API = '/api/publications';

  var rawPublications   = [];
  var allPublications   = [];
  $scope.publications   = [];
  $scope.categories     = [];
  $scope.isLoading      = true;
  $scope.showModal      = false;
  $scope.saving         = false;
  $scope.currentPage    = 1;
  $scope.itemsPerPage   = 10;
  $scope.pageSizeOptions = [10, 20, 50, 0];
  $scope.totalItems     = 0;
  $scope.totalPages     = 0;
  $scope.searchQuery    = '';
  $scope.filterCategory = '';
  $scope.editingPub     = {};
  $scope.successMsg     = '';
  $scope.errorMsg       = '';
  $scope.uploadingPdf   = false;
  $scope.dropOver       = false;

  function paginate() {
    var size = parseInt($scope.itemsPerPage, 10);
    if (!size) {
      $scope.publications = allPublications;
      $scope.totalPages   = 1;
    } else {
      var start = ($scope.currentPage - 1) * size;
      $scope.publications = allPublications.slice(start, start + size);
      $scope.totalPages   = Math.ceil(allPublications.length / size) || 1;
    }
  }

  $scope.changePageSize = function() {
    $scope.currentPage = 1;
    paginate();
  };

  function applyFilters() {
    var q   = ($scope.searchQuery   || '').toLowerCase().trim();
    var cat = ($scope.filterCategory || '').trim();
    allPublications = rawPublications.filter(function(pub) {
      var matchQ = !q || [
        pub.title || '',
        pub.description || '',
        pub.author || ''
      ].some(function(f) { return f.toLowerCase().indexOf(q) !== -1; });
      var matchCat = !cat || (pub.category && pub.category.id === cat);
      return matchQ && matchCat;
    });
    $scope.totalItems  = allPublications.length;
    $scope.currentPage = 1;
    paginate();
  }

  var searchTimeout;

  function flash(type, msg) {
    $scope[type] = msg;
    $timeout(function() { $scope[type] = ''; }, 3500);
  }

  $scope.loadPublications = function() {
    $scope.isLoading = true;
    $http.get(API)
      .then(function(res) {
        var data = res.data;
        rawPublications     = Array.isArray(data) ? data : (data.content || []);
        applyFilters();
      })
      .catch(function() { flash('errorMsg', 'Erreur lors du chargement des publications.'); })
      .finally(function() { $scope.isLoading = false; });
  };

  function loadCategories() {
    $http.get(API + '/categories')
      .then(function(res) { $scope.categories = res.data || []; })
      .catch(angular.noop);
  }

  $scope.onSearch = function() {
    if (searchTimeout) $timeout.cancel(searchTimeout);
    searchTimeout = $timeout(function() { applyFilters(); }, 300);
  };

  $scope.onCategoryChange = function() {
    applyFilters();
  };

  $scope.setPage = function(p) {
    if (p < 1 || p > $scope.totalPages) return;
    $scope.currentPage = p;
    paginate();
  };

  $scope.getPages = function() {
    var pages = [], start = Math.max(1, $scope.currentPage - 2), end = Math.min($scope.totalPages, $scope.currentPage + 2);
    for (var i = start; i <= end; i++) pages.push(i);
    return pages;
  };

  // ── Upload PDF ──────────────────────────────────────────────────────────
  var UPLOAD_API = '/api/upload/pdf';

  $scope.getPdfFilename = function(url) {
    if (!url) return '';
    var parts = url.split('/');
    var name = parts[parts.length - 1];
    var uuidPart = name.indexOf('_');
    return uuidPart >= 0 ? name.substring(uuidPart + 1) : name;
  };

  function uploadFile(file) {
    if (!file) return;
    $scope.uploadingPdf = true;
    var formData = new FormData();
    formData.append('file', file);
    $http.post(UPLOAD_API, formData, {
      transformRequest: angular.identity,
      headers: { 'Content-Type': undefined }
    })
    .then(function(res) {
      $scope.editingPub.pdfUrl = res.data.url;
    })
    .catch(function(err) {
      var msg = (err.data && typeof err.data === 'string') ? err.data : 'Erreur lors de l\'envoi du fichier.';
      flash('errorMsg', msg);
    })
    .finally(function() { $scope.uploadingPdf = false; });
  }

  $scope.triggerFileInput = function() {
    if ($scope.editingPub.pdfUrl) return;
    document.getElementById('pdfFileInput').click();
  };

  $scope.onFileSelected = function(input) {
    if (input.files && input.files[0]) {
      uploadFile(input.files[0]);
      input.value = '';
    }
  };

  $scope.handleDrop = function(event) {
    if ($scope.editingPub.pdfUrl || $scope.uploadingPdf) return;
    var files = event.dataTransfer && event.dataTransfer.files;
    if (files && files.length > 0) uploadFile(files[0]);
  };

  $scope.removePdf = function($event) {
    if ($event) { $event.preventDefault(); $event.stopPropagation(); }
    $scope.editingPub.pdfUrl = '';
  };

  $scope.getCategoryName = function(pub) {
    if (!pub || !pub.category) return '—';
    return pub.category.name || pub.category.id || '—';
  };

  // ── Types ────────────────────────────────────────────────────────────────
  $scope.types = [
    { value: 'rapport', label: 'Rapport' },
    { value: 'etude',   label: 'Étude' },
    { value: 'budget',  label: 'Budget' },
    { value: 'loi',     label: 'Loi / Texte' },
    { value: 'note',    label: 'Note de synthèse' },
    { value: 'autre',   label: 'Autre' }
  ];

  $scope.showNewTypeForm = false;
  $scope.typeForm        = { label: '' };

  $scope.toggleNewTypeForm = function() {
    $scope.showNewTypeForm  = !$scope.showNewTypeForm;
    $scope.typeForm.label   = '';
  };

  $scope.addType = function() {
    var label = ($scope.typeForm.label || '').trim();
    if (!label) { return; }
    var value = label.toLowerCase().replace(/[^a-z0-9]+/g, '-');
    if (!$scope.types.some(function(t) { return t.value === value; })) {
      $scope.types.push({ value: value, label: label });
    }
    $scope.editingPub.type  = value;
    $scope.showNewTypeForm  = false;
    $scope.typeForm.label   = '';
  };

  // ── Nouvelle catégorie ──────────────────────────────────────────────────
  $scope.showNewCategoryForm = false;
  $scope.catForm             = { name: '' };
  $scope.savingCategory      = false;

  $scope.toggleNewCategoryForm = function() {
    $scope.showNewCategoryForm = !$scope.showNewCategoryForm;
    $scope.catForm.name        = '';
  };

  $scope.addCategory = function() {
    var name = ($scope.catForm.name || '').trim();
    if (!name) { return; }
    var code = name.toLowerCase().replace(/[^a-z0-9]+/g, '-');
    $scope.savingCategory = true;
    $http.post(API + '/categories', { code: code, name: name })
      .then(function(res) {
        var catCode = res.data.code || code;
        var catName = res.data.name || name;
        if (!$scope.categories.some(function(c) { return c.id === catCode; })) {
          $scope.categories.push({ id: catCode, name: catName, count: 0 });
        }
        $scope.editingPub.categoryCode = catCode;
        $scope.showNewCategoryForm     = false;
        $scope.catForm.name            = '';
      })
      .catch(function(err) {
        flash('errorMsg', 'Erreur lors de la création de la catégorie (' + (err.status || '?') + ').');
      })
      .finally(function() { $scope.savingCategory = false; });
  };

  $scope.openModal = function(pub) {
    if (pub) {
      $scope.editingPub = angular.copy(pub);
      $scope.editingPub.categoryCode = pub.category ? pub.category.id : '';
      var pd = pub.publicationDate;
      if (Array.isArray(pd)) {
        var y = pd[0], m = pd[1] < 10 ? '0' + pd[1] : pd[1], d = pd[2] < 10 ? '0' + pd[2] : pd[2];
        $scope.editingPub.publicationDateStr = y + '-' + m + '-' + d;
      } else {
        $scope.editingPub.publicationDateStr = pd ? pd.substring(0, 10) : '';
      }
    } else {
      $scope.editingPub = { featured: false, publicationDateStr: '' };
      Auth.identity().then(function(user) {
        if (user && !$scope.editingPub.author) {
          $scope.editingPub.author = (user.firstName || '') + (user.lastName ? ' ' + user.lastName : '');
        }
      });
    }
    $scope.uploadingPdf = false;
    $scope.dropOver     = false;
    $scope.showModal    = true;
  };

  $scope.closeModal = function() {
    $scope.showModal           = false;
    $scope.editingPub          = {};
    $scope.uploadingPdf        = false;
    $scope.dropOver            = false;
    $scope.showNewCategoryForm = false;
    $scope.catForm.name        = '';
    $scope.showNewTypeForm     = false;
    $scope.typeForm.label      = '';
  };

  $scope.savePublication = function() {
    if (!$scope.editingPub.title) { flash('errorMsg', 'Le titre est obligatoire.'); return; }
    $scope.saving = true;
    var payload = {
      title:           $scope.editingPub.title,
      description:     $scope.editingPub.description,
      author:          $scope.editingPub.author,
      pdfUrl:          $scope.editingPub.pdfUrl || '',
      type:            $scope.editingPub.type,
      featured:        !!$scope.editingPub.featured,
      categoryCode:    $scope.editingPub.categoryCode || '',
      categoryName:    $scope.editingPub.categoryName  || '',
      publicationDate: $scope.editingPub.publicationDateStr || ''
    };
    var isEdit = !!$scope.editingPub.id;
    var req = isEdit
      ? $http.put(API + '/' + $scope.editingPub.id, payload)
      : $http.post(API, payload);

    req.then(function() {
      $scope.closeModal();
      $scope.loadPublications();
      flash('successMsg', isEdit ? 'Publication mise à jour.' : 'Publication créée.');
    })
    .catch(function(err) {
      var msg = (err.data && typeof err.data === 'string') ? err.data : 'Erreur lors de l\'enregistrement.';
      flash('errorMsg', msg);
    })
    .finally(function() { $scope.saving = false; });
  };

  $scope.formatDate = function(date) {
    if (!date) return '—';
    var d, day, month, year;
    if (Array.isArray(date)) {
      year = date[0]; month = date[1]; day = date[2];
    } else {
      d = new Date(date);
      if (isNaN(d.getTime())) return '—';
      day = d.getDate(); month = d.getMonth() + 1; year = d.getFullYear();
    }
    return (day < 10 ? '0' + day : '' + day) + '/' +
           (month < 10 ? '0' + month : '' + month) + '/' + year;
  };

  $scope.deletePublication = function(pub) {
    if (!confirm('Supprimer "' + pub.title + '" ?')) return;
    $http.delete(API + '/' + pub.id)
      .then(function() { $scope.loadPublications(); flash('successMsg', 'Publication supprimée.'); })
      .catch(function() { flash('errorMsg', 'Erreur lors de la suppression.'); });
  };

  // ── Export ────────────────────────────────────────────────────────────────
  $scope.showExportMenu = false;
  $scope.toggleExportMenu = function($event) { $event.stopPropagation(); $scope.showExportMenu = !$scope.showExportMenu; };
  var _hideMenu = function() { $scope.$applyAsync(function() { $scope.showExportMenu = false; $scope.showColPicker = false; }); };
  document.addEventListener('click', _hideMenu);
  $scope.$on('$destroy', function() { document.removeEventListener('click', _hideMenu); });

  $scope.showColPicker = false;
  $scope.toggleColPicker = function($event) { $event.stopPropagation(); $scope.showColPicker = !$scope.showColPicker; $scope.showExportMenu = false; };
  $scope.col = { categorie: true, auteur: true, date: true, vues: true };
  var COL_DEFS = [
    { key: 'titre',     label: 'Titre',            fn: function(p){ return p.title||''; } },
    { key: 'categorie', label: 'Catégorie',         fn: function(p){ return $scope.getCategoryName(p); } },
    { key: 'auteur',    label: 'Auteur',           fn: function(p){ return p.author||''; } },
    { key: 'date',      label: 'Date publication', fn: function(p){ return $scope.formatDate(p.publicationDate); } }
  ];
  function visibleDefs() { return COL_DEFS.filter(function(d){ return d.key === 'titre' || $scope.col[d.key]; }); }
  function getExportRows() {
    var defs = visibleDefs();
    return allPublications.map(function(p) { return defs.map(function(d){ return d.fn(p); }); });
  }
  function getExportHeaders() { return visibleDefs().map(function(d){ return d.label; }); }
  function escHtml(s) { return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }
  function triggerDl(blob, name) {
    var url = URL.createObjectURL(blob), a = document.createElement('a');
    a.href = url; a.download = name; document.body.appendChild(a); a.click(); document.body.removeChild(a);
    $timeout(function() { URL.revokeObjectURL(url); }, 500);
  }
  $scope.exportCSV = function() {
    $scope.showExportMenu = false;
    var rows = getExportRows().map(function(r) { return r.map(function(v) { return '"'+String(v).replace(/"/g,'""')+'"'; }).join(';'); });
    triggerDl(new Blob(['\uFEFF'+getExportHeaders().join(';')+'\n'+rows.join('\n')], {type:'text/csv;charset=utf-8;'}), 'publications.csv');
  };
  $scope.exportExcel = function() {
    $scope.showExportMenu = false;
    var cell='border:1px solid #b0bec5;padding:6px 10px;font-size:11pt;font-family:Calibri,Arial,sans-serif;vertical-align:middle;', rows=getExportRows(), hdrs=getExportHeaders();
    var html='<html><head><meta charset="utf-8"/></head><body><table style="border-collapse:collapse">';
    html+='<tr><td colspan="'+hdrs.length+'" style="'+cell+'background:#0f2544;color:#fff;font-size:14pt;font-weight:bold;text-align:center;padding:12px;">Publications</td></tr>';
    html+='<tr><td colspan="'+hdrs.length+'" style="'+cell+'background:#e8edf5;color:#555;font-size:9pt;text-align:center;">Exporté le '+new Date().toLocaleDateString('fr-FR')+' — '+rows.length+' entrée(s)</td></tr>';
    html+='<tr>'+hdrs.map(function(h){return'<th style="'+cell+'background:#1e3a5f;color:#fff;font-weight:bold;">'+h+'</th>';}).join('')+'</tr>';
    rows.forEach(function(r,i){var bg=i%2===0?'#f0f4fa':'#fff';html+='<tr>'+r.map(function(v){return'<td style="'+cell+'background:'+bg+';">'+escHtml(v)+'</td>';}).join('')+'</tr>';});
    html+='</table></body></html>';
    triggerDl(new Blob(['\uFEFF'+html],{type:'application/vnd.ms-excel;charset=utf-8;'}), 'publications.xls');
  };

  $scope.loadPublications();
  loadCategories();
}]);
